import type { FoodCategory } from "../data";

export const categoryIcons: Record<FoodCategory, string> = {
  all: "🍽️", soups: "🍲", salads: "🥗",
  desserts: "🍮", breakfast: "🍳", grilled: "🔥", seafood: "🦞", pastries: "🥐", juices: "🧃",
  athletes: "🏋️",
};

export const ingredientCategories = {
  vegetables: { icon: "🥦", ar: "الخضروات", en: "Vegetables", de: "Gemüse", ru: "Овощи", pt: "Legumes" },
  proteins: { icon: "🥩", ar: "البروتينات", en: "Proteins", de: "Proteine", ru: "Белки", pt: "Proteínas" },
  seafood: { icon: "🐟", ar: "المأكولات البحرية", en: "Seafood", de: "Meeresfrüchte", ru: "Морепродукты", pt: "Frutos do mar" },
  dairy: { icon: "🧀", ar: "الألبان والكريمة", en: "Dairy & Cream", de: "Milchprodukte", ru: "Молочные", pt: "Laticínios" },
  grains: { icon: "🌾", ar: "الحبوب والدقيق", en: "Grains & Flour", de: "Getreide", ru: "Злаки", pt: "Grãos" },
  fruits: { icon: "🍋", ar: "الفواكه", en: "Fruits", de: "Früchte", ru: "Фрукты", pt: "Frutas" },
  condiments: { icon: "🫒", ar: "التوابل والزيوت والسكر", en: "Condiments & Sweets", de: "Gewürze", ru: "Приправы", pt: "Condimentos" },
  legumes: { icon: "🫘", ar: "البقوليات", en: "Legumes", de: "Hülsenfrüchte", ru: "Бобовые", pt: "Leguminosas" },
  beverages: { icon: "🧃", ar: "المشروبات والعصائر", en: "Beverages & Juices", de: "Getränke & Säfte", ru: "Напитки и соки", pt: "Bebidas & Sucos" },
};
